import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as dynamicEcs from '../../../../../dynamic-ecs'
import * as models from '../../../../../models'
import type { Plugin } from '../plugin'

/**
 * When new widget is focused on, we immediately load its preview
 */
export const triggerEcDispose = store.effects.create(
  (
    feature: Plugin['feature'],
    plugin: Plugin,
    dynamicEcsFeature: dynamicEcs.Feature,
  ) =>
    rxjs
      .merge(
        plugin.collection.plugins.editingPlugin.feature.actions.submit.success.observe(),
        plugin.collection.plugins.editingPlugin.feature.actions.discard.success.observe(),
        feature.actions.preview.request.observe(),
      )
      .pipe(
        rxjs.withLatestFrom(
          dynamicEcsFeature.selectors.getDynamicEc(
            models.widget.Ref.FOR_PREVIEW,
          ).asObservable,
        ),
        rxjs.map(([action, collection]) =>
          // if there are no dynamic EC, that matches the name, we skip the effect
          collection
            ? dynamicEcsFeature.actions.dispose.from(action).create({
                ref: models.widget.Ref.FOR_PREVIEW,
              })
            : store.effects.SKIP,
        ),
      ),
)
